import { pipe } from "fp-ts/function";
import * as t from "io-ts";
import { fold } from "fp-ts/Either";
import { retrieveFromWP } from "@/lib/wordpress/data";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";

const ValidatedApiKeyV = t.type({
  type: t.string,
  message: t.string
});

export type ValidatedApiKey = t.TypeOf<typeof ValidatedApiKeyV>;

export async function getAllApiKeys() {
  return pipe(
    await retrieveFromWP(
      "api_keys",
      t.union([t.literal(false), t.record(t.string, t.string)])
    ),
    fold(
      () => ({}),
      keys => keys
    )
  );
}

export async function validateApiKey(dataToPost: {
  apiKeyName: string;
  apiKey: string;
  apiUrl?: string | null;
}) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_validate_api_key",
      decoder: ValidatedApiKeyV,
      resultKey: "data",
      dataToPost
    }),
    fold(
      () => ({
        type: "error",
        message: "Server error while validating the API key"
      }),
      result => result
    )
  );
}
